export function matchesServiceDateRange(order, { from = '', to = '' } = {}) {
  if (!from && !to) return true;
  const date = String(order.departure_date || '').slice(0, 10);
  return Boolean(date) && (!from || date >= from) && (!to || date <= to);
}

export function serviceDateFetchParams(range = {}) {
  if (!range.from && !range.to) return {};
  return { month: undefined, date_from: range.from || undefined, date_to: range.to || undefined };
}
